import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b00b71e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-category-modal" }
const _hoisted_2 = {
  key: 0,
  class: "items-in-column gap--20 mt--20"
}
const _hoisted_3 = { class: "center" }

import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { ref, Ref, watch } from 'vue';
import { CreateCategoryModalType, ErrorsType, OptionsType } from '@/types';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useDevelopersStore } from '@/store/modules/developers';
import { useUserStore } from '@/store/modules/user';
import { LegalEntitiesType } from '@/api/developer/types';
import AnnouncementsFilterInputs from '@/components/ProfileComponents/AnnounsmentsFilterInputs/AnnouncementsFilterInputs.vue';

type FormDataType = {
  newTitle: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDeveloperModal',
  props: {
    createCategoryModalData: {},
    isResidentialComplex: { type: Boolean },
    isOfferCard: { type: Boolean }
  },
  emits: ['createCategory', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const errors: Ref<ErrorsType> = ref({});
const isCreateCategoryLoading = ref(false);
const listLegalEntitiesOptions: Ref<OptionsType[]> = ref([]);
const currentEntitiesOptions: Ref<number | undefined> = ref(undefined);
const legalEntityId: Ref<number | undefined> = ref(undefined);
const developerId: Ref<number | undefined> = ref(undefined);
const residentialComplexId: Ref<number | undefined> = ref(undefined);
const constructionLineId: Ref<number | undefined> = ref(undefined);
const categoryId: Ref<number | string | undefined> = ref(undefined);
const formData: Ref<FormDataType> = ref({
  newTitle: '',
});

const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  newTitle: { required },
};
const prepareList = (res: LegalEntitiesType | undefined) => {
  if (res) {
    categoryId.value = res.childCategory;

    return res.list?.map(el => {
      return {
        id: el.id,
        name: el.value,
      };
    });
  } else {
    return [];
  }
};
const validationErrorsHandlerByKey = (key: string | number) => {
  let error: string | undefined = errorsHandlerByKey(String(key), rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};
const v$ = useVuelidate<FormDataType>(rules, formData, {
  $autoDirty: true,
  $stopPropagation: true,
});
const clearFormData = () => {
  v$.value.$reset();
  formData.value.newTitle = '';
  residentialComplexId.value = undefined;
  legalEntityId.value = undefined;
  developerId.value = undefined;
  constructionLineId.value = undefined;
};
const closeCreateCategoryModal = () => {
  clearFormData();
  emit('close');
};
const createCategory = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  if (categoryId.value) {
    let parentId;

    if (props.isOfferCard && useUserStore().user?.is_construction_company) {
      parentId = constructionLineId.value;
    } else if (props.isOfferCard) {
      parentId =
        residentialComplexId.value === 0 ? undefined : residentialComplexId.value;
    } else if (props.isResidentialComplex) {
      parentId = legalEntityId.value;
    } else {
      parentId = props.createCategoryModalData.parentId;
    }
    try {
      isCreateCategoryLoading.value = true;
      const preparedData = {
        categoryId: String(categoryId.value),
        parentId: parentId,
        value: formData.value.newTitle,
      };
      const res = await useDevelopersStore().createCategoryValue(preparedData);

      if (res) {
        emit('createCategory', {
          id: res.id,
          title: formData.value.newTitle,
          url: res.customUrl,
        });
        closeCreateCategoryModal();
      }
    } catch (error) {
      errors.value = validationErrorsByRequest(error);
    } finally {
      isCreateCategoryLoading.value = false;
    }
  }
};

watch(
  () => props.createCategoryModalData.show,
  async () => {
    if (props.createCategoryModalData.show) {
      if (props.isResidentialComplex || props.isOfferCard) {
        if (props.isResidentialComplex) {
          await useDevelopersStore()
            .getLegalEntities()
            .then(res => {
              listLegalEntitiesOptions.value = prepareList(res);
            });
        }
      } else {
        categoryId.value = props.createCategoryModalData.categoryId;
        currentEntitiesOptions.value = props.createCategoryModalData.parentId;
      }
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.createCategoryModalData.show,
    title: `Создание сущности категории '${_ctx.createCategoryModalData.categoryTitle}'`,
    onClose: closeCreateCategoryModal
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_form, {
          class: "mb--20",
          onSubmit: _cache[8] || (_cache[8] = ($event: any) => (createCategory()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_input, {
              modelValue: formData.value.newTitle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.newTitle) = $event)),
              error: errors.value.newTitle,
              invalid: !!errors.value.newTitle,
              height: "36",
              hideArrows: "",
              label: "Название",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('newTitle'))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.newTitle)),
              onInput: _unref(v$).newTitle.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
            (_ctx.isOfferCard)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(AnnouncementsFilterInputs, {
                    categoryId: categoryId.value,
                    "onUpdate:categoryId": _cache[3] || (_cache[3] = ($event: any) => ((categoryId).value = $event)),
                    constructionLineId: constructionLineId.value,
                    "onUpdate:constructionLineId": _cache[4] || (_cache[4] = ($event: any) => ((constructionLineId).value = $event)),
                    developerId: developerId.value,
                    "onUpdate:developerId": _cache[5] || (_cache[5] = ($event: any) => ((developerId).value = $event)),
                    residentialComplexId: residentialComplexId.value,
                    "onUpdate:residentialComplexId": _cache[6] || (_cache[6] = ($event: any) => ((residentialComplexId).value = $event))
                  }, null, 8, ["categoryId", "constructionLineId", "developerId", "residentialComplexId"])
                ]))
              : (_ctx.isResidentialComplex)
                ? (_openBlock(), _createBlock(_component_base_select_input, {
                    key: 1,
                    modelValue: legalEntityId.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((legalEntityId).value = $event)),
                    options: listLegalEntitiesOptions.value,
                    class: "mt--20",
                    label: "Выберите Юр. Лицо"
                  }, null, 8, ["modelValue", "options"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_base_button, {
            loading: isCreateCategoryLoading.value,
            height: "40",
            text: "Сохранить",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (createCategory()))
          }, null, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show-modal", "title"]))
}
}

})